/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
	let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let Y = date.getFullYear() + '-'
	let M =
		(date.getMonth() + 1 < 10 ?
			'0' + (date.getMonth() + 1) :
			date.getMonth() + 1) + '-'
	let D =
		(date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
	let h =
		(date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
	let m =
		(date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
		':'
	let s =
		date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
	return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
	if (!name) return;
	return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
	let date = new Date();
	date.setDate(date.getDate() + day);
	document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
	let reg = RegExp(name + '=([^;]+)');
	let arr = document.cookie.match(reg);
	if (arr) {
		return arr[1];
	} else {
		return '';
	}
};

/**
 * 删除cookie
 **/
function delCookie(name) {
	setCookie(name, null, -1);
};

/**
 * 复制到剪贴板
 **/
function fallbackCopyTextToClipboard(copyInfo) {
	var textArea = document.createElement('textarea');
	textArea.value = copyInfo.getText();

	// Avoid scrolling to bottom
	textArea.style.top = '0';
	textArea.style.left = '0';
	textArea.style.position = 'fixed';

	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		var successful = document.execCommand('copy');
		setTimeout(function() {
			if (successful) {
				copyInfo.success();
			} else {
				copyInfo.error();
			}
		}, 1);
	} catch (err) {
		setTimeout(function() {
			copyInfo.error(err);
		}, 1);
	}

	document.body.removeChild(textArea);
}
/** @param {CopyInfo} copyInfo */
function copyTextToClipboard(copyInfo) {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(copyInfo.getText()).then(copyInfo.success, function() {
			// try the fallback in case `writeText` didn't work
			fallbackCopyTextToClipboard(copyInfo);
		});
	} else {
		fallbackCopyTextToClipboard(copyInfo);
	}
}

/**
 * 导出 
 **/
export {
	timestampToTime,
	setStore,
	getStore,
	removeStore,
	setCookie,
	getCookie,
	delCookie,
	copyTextToClipboard
}


// WEBPACK FOOTER //
// ./src/utils/util.js